import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ChangeDetectorRef  } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogDossierLabelComponent } from 'src/app/views/dialogs/dialog-dossier-label/label.component';
@Component({
  selector: 'app-dossier-info',
  templateUrl: './dossier-info.component.html',
  styleUrls: ['./dossier-info.component.scss']
})
export class DossierInfoComponent implements OnInit {
  @Input() dossier: any;
  @Output() dossierLabelChanged = new EventEmitter<string>();

  constructor(
    public dialog: MatDialog,
    private cdf: ChangeDetectorRef,
  ) {}

  ngOnInit() {
  }
  
  changeDossierLabel(dossier)
  {
    this.openChangeDossierLabel(dossier).afterClosed().subscribe(result => {
      if(result.label && result.saved){
        dossier.dossier_label = result.label;
        this.dossierLabelChanged.emit(dossier);
        this.cdf.detectChanges();
      }
    });
  }

  openChangeDossierLabel(dossier, title = "", duplication = false)
  {
    const dialogRef = this.dialog.open(DialogDossierLabelComponent, {
      width: '50%',
      maxWidth:'50%',
      data: {
        "title": title,
        "dossier": dossier,
        "duplication": duplication
      }
    });
    return dialogRef;
  }

}
